import { render } from "./ResultatsCoureur.vue?vue&type=template&id=705b32f2"
import script from "./ResultatsCoureur.vue?vue&type=script&lang=js"
export * from "./ResultatsCoureur.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__